import { render, staticRenderFns } from "./studyMain1.vue?vue&type=template&id=5f3a108c&scoped=true"
import script from "./studyMain1.vue?vue&type=script&lang=js"
export * from "./studyMain1.vue?vue&type=script&lang=js"
import style0 from "./studyMain1.vue?vue&type=style&index=0&id=5f3a108c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3a108c",
  null
  
)

export default component.exports